<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'branch/index' }">
                                Cabang
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'branch/view', params: {id: intensiveClass.intensiveSchedule.branchProgram.branchID} }">
                                {{ intensiveClass.intensiveSchedule.branchProgram.branch.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-if="roleElligibleModified()" v-bind:to="{ name: 'branch/program/edit', params: {id: intensiveClass.intensiveSchedule.branchProgram.branchID, programID: intensiveClass.intensiveSchedule.branchProgramID} }">
                                {{ intensiveClass.intensiveSchedule.branchProgram.grade.name }} - {{ intensiveClass.intensiveSchedule.branchProgram.programType.name }}
                            </router-link>
                            <router-link v-else v-bind:to="{ name: 'branch/view', params: {id: intensiveClass.intensiveSchedule.branchProgram.branchID} }">
                                {{ intensiveClass.intensiveSchedule.branchProgram.grade.name }} - {{ intensiveClass.intensiveSchedule.branchProgram.programType.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'branch/program/intensive/view', params: {id: intensiveClass.intensiveSchedule.branchProgram.branchID, programID: intensiveClass.intensiveSchedule.branchProgramID, intensiveID: intensiveClass.intensiveScheduleID} }">
                                {{ intensiveClass.intensiveSchedule.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ intensiveClass.name }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col mt-2">
                <h4 class="text-danger font-weight-bold mb-3">Kelas Intensif</h4>
                <div class="row">
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Cabang</h4>
                        <p class="font-weight-bold mb-0">{{ intensiveClass.intensiveSchedule.branchProgram.branch.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Kelas</h4>
                        <p class="font-weight-bold mb-0">{{ intensiveClass.intensiveSchedule.branchProgram.grade.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Tipe Program</h4>
                        <p class="font-weight-bold mb-0">{{ intensiveClass.intensiveSchedule.branchProgram.programType.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Sesi</h4>
                        <p class="font-weight-bold mb-0">{{ intensiveClass.intensiveSchedule.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Nama Kelas</h4>
                        <p class="font-weight-bold mb-0">{{ intensiveClass.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Kapasitas</h4>
                        <p class="font-weight-bold mb-0">{{ intensiveClass.currentCapacity }}/{{ intensiveClass.capacity }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <div id="table-primary" class="table-responsive" v-dragscroll="!isMobile()">
                    <table class="table">
                        <thead>
                            <tr class="text-danger font-weight-bold">
                                <th scope="col" name="identity" v-on:click="sort">
                                    No. Peserta <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" name="name" v-on:click="sort">
                                    Nama Lengkap <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" name="schoolID" v-on:click="sort">
                                    Asal Sekolah <i class="fa fa-chevron-down"></i>
                                </th>
                                <template v-if="roleElligibleView()">
                                    <th scope="col" v-for="profileLabel in profileLabels" v-bind:name="profileLabel" v-on:click="sort">
                                        {{ humanize(profileLabel) }} <i class="fa fa-chevron-down"></i>
                                    </th>
                                </template>
                                <th scope="col" v-if="roleElligiblePartialView() || roleElligibleView()">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="shadow-sm" v-for="student in students" v-bind:key="student.userID">
                                <td>
                                    <span class="text-loading">{{ student.identity }}</span>
                                </td>
                                <td>
                                    <span class="text-loading" v-if="student.user">{{ student.user.name }}</span>
                                </td>
                                <td>
                                    <span class="text-loading" v-if="student.school">{{ student.school.name }}</span>
                                </td>
                                <template v-if="roleElligibleView()">
                                    <td v-for="profileLabel in profileLabels">
                                        <span v-bind:class="{'text-loading': typeof student.additionals[profileLabel] === typeof undefined}">{{ renderCheckBlank(student.additionals[profileLabel]) }}</span>
                                    </td>
                                </template>
                                <td v-if="roleElligiblePartialView()">
                                    <router-link v-bind:to="{name: 'student/score', params: {id: student.userID}}" class="text-loading">
                                        Laporan Nilai
                                    </router-link>
                                </td>
                                <td v-else-if="roleElligibleView()">
                                    <router-link v-bind:to="{name: 'student/view', params: {id: student.userID}}" class="text-loading">
                                        Detail
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>
    </section>
</template>

<script>
    import Paginate from 'vuejs-paginate';
    import { dragscroll } from 'vue-dragscroll';
    import { mapState } from 'vuex';

    export default {
        name: "BranchProgramIntensiveClassView",
        directives: {dragscroll},
        components: {
            Paginate
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {
                    sortColumn: 'identity',
                    sortType: 'asc'
                },
                tryouts: {},
                intensiveClass: {intensiveSchedule: {branchProgram: {branch: {}, grade: {}, programType: {}}}},
                students: [
                    {user: {}, school: {}, additionals: {}},
                    {user: {}, school: {}, additionals: {}},
                    {user: {}, school: {}, additionals: {}},
                    {user: {}, school: {}, additionals: {}},
                    {user: {}, school: {}, additionals: {}},
                    {user: {}, school: {}, additionals: {}},
                    {user: {}, school: {}, additionals: {}},
                    {user: {}, school: {}, additionals: {}},
                    {user: {}, school: {}, additionals: {}},
                    {user: {}, school: {}, additionals: {}}
                ],
                pageCount: 0,
                page: 1,
                profileLabels: ['nomor_hp_siswa', 'nomor_hp_ayah', 'nomor_hp_ibu']
            };
        },
        methods: {
            paginate(page, scroll = true) {
                this.axios.get(process.env.API_URL + '/student', {params: Object.assign({}, this.form, {page: page, intensiveClassID: this.intensiveClass.id})}).then(response => {
                    this.students = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;

                    if (scroll) {
                        document.getElementById('table-primary').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            },
            sort(event) {
                var column = event.currentTarget;
                var columnName = column.getAttribute("name");
                if (columnName) {
                    this.form.sortType = (this.form.sortColumn !== columnName || this.form.sortType !== 'asc') ? 'asc' : 'desc';
                    this.form.sortColumn = columnName;

                    document.querySelectorAll("table tr th[sort]").forEach(element => {
                        element.removeAttribute("sort");
                    });
                    column.setAttribute("sort", this.form.sortType);
                }
                this.paginate(1);
            },
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            },
            renderCheckBlank(value) {
                return (value !== '' && value !== null) || typeof value === typeof undefined ? value : " ";
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            },
            roleElligibleModified() {
                return this.profile.isAdmin;
            },
            roleElligibleView() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isDirector || this.profile.employee.isManager || this.profile.employee.isBranchHead || this.profile.employee.isBranchStaff));
            },
            roleElligiblePartialView() {
                return this.profile.isEmployee && (this.profile.employee.isMentor || this.profile.employee.isTeacher);
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/intensive-class/' + this.$route.params.classID).then(response => {
                this.intensiveClass = response.data.data;
                this.paginate(1, false);

                document.title = this.intensiveClass.name + ' - ' + process.env.APP_NAME;
            });
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/branch/program/intensive/class/View.vue